const carrierTypes = {
	amazon: 'Amazon Shipping',
	ups: 'UPS',
	fedex: 'FedEx',
	stamps: 'Stamps.com',
};

export { carrierTypes };



// WEBPACK FOOTER //
// ./src/common/constants/carrierTypes.js